// @flow
import Vue from 'vue'
import { SET_USER, SET_USER_VALIDATION_ERRORS, SET_TOKEN } from './mutation-types'
import type { UserApiClientInterface } from '../../../user-api/user-api-client-interface'
import type { UserState } from './index'
import type { DispatchFunction, CommitFunction } from '../../types'

export default {
  fetchIsUserLoggedIn: async ({ commit, state }: { state: Object, commit: (string, ?Object) => void }) => {
    const client: UserApiClientInterface = Vue.prototype.$container.userApiClient
    if (state.token !== null) {
      await client.getJwtUser(state.token)
    } else {
      await client.getUser()
    }
  },

  fetchUser: async ({ commit, state }: { state: Object, commit: (string, ?Object) => void }) => {
    const client: UserApiClientInterface = Vue.prototype.$container.userApiClient
    try {
      const updatedUser = state.token !== null
        ? await client.getJwtUser(state.token)
        : await client.getUser()
      commit(SET_USER, updatedUser)
    } catch (e) {
      commit(SET_USER, null)
      throw e
    }
  },

  tryFetchUser: async ({ commit, state }: { state: Object, commit: (string, ?Object) => void }) => {
    const client: UserApiClientInterface = Vue.prototype.$container.userApiClient
    try {
      const updatedUser = state.token !== null
        ? await client.getJwtUser(state.token)
        : await client.getUser()
      commit(SET_USER, updatedUser)
    } catch (e) {
      commit(SET_USER, null)
    }
  },

  storeUserLogin: (
    { commit }: { commit: (string, ?Object) => void },
    data: { username: string, password: string }
  ): Promise<Object> => {
    const { username, password } = data
    return new Promise((resolve, reject) => {
      Vue.prototype.$container.userApiClient.login(username, password, 'store_user')
        .then(response => {
          const token = response.data.token
          commit(SET_TOKEN, token)
          resolve({})
        })
        .catch(error => {
          if (error.response) {
            reject(error.response.data)
          } else {
            console.error(error)
          }
        })
    })
  },

  websiteUserLogin: async (
    { commit }: { commit: (string, ?Object) => void },
    data: { username: string, password: string }
  ): Promise<Object> => {
    const { username, password } = data
    return new Promise((resolve, reject) => {
      Vue.prototype.$container.userApiClient.login(username, password, 'website')
        .then(response => {
          const token = response.data.token
          commit(SET_TOKEN, token)
          resolve({})
        })
        .catch(error => {
          if (error.response) {
            reject(error.response.data)
          } else {
            console.error(error)
          }
        })
    })
  },

  logout: ({ commit }: { commit: (string, ?Object) => void }) => {
    commit(SET_TOKEN, null)
    commit(SET_USER, null)
  },
  updateUser: async ({ state, commit, dispatch }: { state: UserState, commit: CommitFunction, dispatch: DispatchFunction}) => {
    await dispatch('fetchIsUserLoggedIn')
    if (state.user) {
      try {
        await Vue.$container.userApiClient.updateUser(state.user)
        commit(SET_USER_VALIDATION_ERRORS, [])
      } catch (error) {
        if (error.hasOwnProperty('errors')) { // can not use instanceof ValidationError https://github.com/babel/babel/issues/4480
          commit(SET_USER_VALIDATION_ERRORS, error.errors)
        }
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js